module.exports = __webpack_public_path__ + "static/media/waffle.d1e93dfe.svg";